export function getProductGapsDescription(integrationName: string) {
  return `
          Use Ignition’s AI to help automatically identify feature gaps blocking your sales deals from ${integrationName} deal notes
          and call data, then quantify their revenue impact based on blocked deals, and close the loop with reps when
          they ship.
          `
}

export function getProductGapsSteps() {
  return [
    'Identify critical deal blockers with AI',
    'Quantify product roadmap effort based on revenue',
    'Capture open pipeline opportunity by notifying reps when features ship',
  ]
}

export function getWinLossDescription(integrationName: string) {
  return `Extract and visualize win/loss performance vs. each of your key competitors from ${integrationName} CRM.
          Use Ignition’s tools to easily filter and parse key insights into why you’re winning and losing deals.`
}

export function getWinLossSteps() {
  return [
    'Visualize win/loss performance',
    'Identify key win/loss drivers',
    'Use AI to parse insights into how to win more deals',
  ]
}

export function getBattleCardsDescription() {
  return 'Export battlecards, launch calendars, and other key information directly to a widget inside your CRM, so Sales teams can easily access the info they need to close deals.'
}

export function getBattleCardsSteps() {
  return [
    'Embed a widget inside your opportunities',
    'Surface login-free access to battlecards, launch calendars, and more',
  ]
}
